import { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import Button from "react-bootstrap/Button";
import axios from "axios";
import "../../styles.css";
import './style.scss';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const SystemGlobalSettings = () => {
    const { addToast } = useToasts();
    const dispatch = useDispatch();
    const [isBusy, setBusy] = useState(false);
    const [state, setState] = useState({
        max_subscription_price: 0,
        min_subscription_price: 0,
        min_tip_price: 0,
        max_tip_price: 0,
        min_ppv_price: 0,
        max_ppv_price: 0,
        max_users_per_page: 0,
        unverified_subscriber_max_payments: 50,
        auto_pause_days: 30,
        unverified_max_ppv_purchases: 2,
        unverified_max_tip_purchases: 2,
        recently_added_posts: 10,
        subscriber_account_verification: '',
        specified_account_verification: '',
        mass_min_users: 50,
        mass_burst_qty: 1000,
        max_mass_mail_batch_users: 1000,
        max_filesize_download: 100, // 100mb
        max_zip_error: 3,
        max_stash_file_uploads: '',
        thumbprint_duration: 200,
        thumbprint_opacity: 0.1,
        signup_email_verify: 0,
        ccver_threshold_amount: 50,
        ccver_threshold_qty: 2,
        ccver_registration_date: ''
    });

    useEffect(() => {
        getSettingsValue();
    }, []);

    const getSettingsValue = () => {
        setBusy(true);
        axios.get("/api/administration/settings")
            .then((response) => {
                const data = response.data;
                updateState(data.settings);
                setBusy(false);
            })
            .catch((error) => {
                console.log(error.response);
                setBusy(false);
            });
    };

    const updateState = (settings) => {
        console.log(settings);
        settings.forEach(setting => {
            if (state[setting.var_name] != null) {
                state[setting.var_name] = setting.value;
            }
        });

        setState({
            ...state,
            max_subscription_price: state.max_subscription_price,
            min_subscription_price: state.min_subscription_price,
            max_users_per_page: state.max_users_per_page,
            unverified_subscriber_max_payments: state.unverified_subscriber_max_payments,
            auto_pause_days: state.auto_pause_days,
            unverified_max_ppv_purchases: state.unverified_max_ppv_purchases,
            unverified_max_tip_purchases: state.unverified_max_tip_purchases,
            recently_added_posts: state.recently_added_posts,
            subscriber_account_verification: state.subscriber_account_verification == 1,
            specified_account_verification: state.specified_account_verification == 1,
            min_tip_price: state.min_tip_price,
            max_tip_price: state.max_tip_price,
            min_ppv_price: state.min_ppv_price,
            max_ppv_price: state.max_ppv_price,
            mass_min_users: state.mass_min_users,
            mass_burst_qty: state.mass_burst_qty,
            max_mass_mail_batch_users: state.max_mass_mail_batch_users,
            max_filesize_download: state.max_filesize_download,
            max_zip_error: state.max_zip_error,
            max_stash_file_uploads: state.max_stash_file_uploads,
            thumbprint_opacity: state.thumbprint_opacity,
            thumbprint_duration: state.thumbprint_duration,
            signup_email_verify: state.signup_email_verify == 1,
            ccver_threshold_amount: state.ccver_threshold_amount,
            ccver_threshold_qty: state.ccver_threshold_qty,
            ccver_registration_date: state.ccver_registration_date,
        });
    };

    const handleSave = () => {
        const {
            max_subscription_price,
            min_subscription_price,
            max_users_per_page,
            unverified_subscriber_max_payments,
            auto_pause_days,
            unverified_max_ppv_purchases,
            unverified_max_tip_purchases,
            recently_added_posts,
            subscriber_account_verification,
            specified_account_verification,
            min_tip_price,
            max_tip_price,
            min_ppv_price,
            max_ppv_price,
            mass_min_users,
            mass_burst_qty,
            max_mass_mail_batch_users,
            max_filesize_download,
            max_zip_error,
            max_stash_file_uploads,
            thumbprint_opacity,
            thumbprint_duration,
            signup_email_verify,
            ccver_threshold_amount,
            ccver_threshold_qty,
            ccver_registration_date
        } = state;

        if (!ccver_threshold_amount || ccver_threshold_amount <= 0) {
            return addToast('Amount threshold is required', { appearance: 'error', autoDismiss: true });
        }

        if (!ccver_threshold_amount || ccver_threshold_amount <= 0) {
            return addToast('Quantity threshold is required', { appearance: 'error', autoDismiss: true });
        }

        if (!ccver_registration_date || ccver_registration_date.length <= 0) {
            return addToast('Start Registration Date', { appearance: 'error', autoDismiss: true });
        }
        setBusy(true);
        axios.post("/api/administration/settings/save", {
            max_subscription_price: max_subscription_price,
            min_subscription_price: min_subscription_price,
            max_users_per_page: max_users_per_page,
            unverified_subscriber_max_payments: unverified_subscriber_max_payments,
            auto_pause_days: auto_pause_days,
            unverified_max_ppv_purchases: unverified_max_ppv_purchases,
            unverified_max_tip_purchases: unverified_max_tip_purchases,
            recently_added_posts: recently_added_posts,
            subscriber_account_verification: subscriber_account_verification,
            specified_account_verification: specified_account_verification,
            min_tip_price: min_tip_price,
            max_tip_price: max_tip_price,
            min_ppv_price: min_ppv_price,
            max_ppv_price: max_ppv_price,
            mass_min_users: mass_min_users,
            mass_burst_qty: mass_burst_qty,
            max_mass_mail_batch_users: max_mass_mail_batch_users,
            max_filesize_download: max_filesize_download,
            max_zip_error: max_zip_error,
            max_stash_file_uploads: max_stash_file_uploads,
            thumbprint_duration: thumbprint_duration,
            thumbprint_opacity: thumbprint_opacity,
            signup_email_verify: signup_email_verify,
            ccver_threshold_amount: ccver_threshold_amount,
            ccver_threshold_qty: ccver_threshold_qty,
            ccver_registration_date: ccver_registration_date
        })
            .then((response) => {
                const data = response.data;
                setBusy(false);
                return addToast(data.message, { appearance: 'success', autoDismiss: true });
            })
            .catch((error) => {
                console.log(error.response);
                setBusy(false);
                return addToast('Error on saving settings.', { appearance: 'error', autoDismiss: true });
            });
    };

    const handleChange = (key, value) => {
        setState({ ...state, [key]: value });
    };

    return (
        <div className="col-md-8 global-settings">
            <h3 className="mb-4">System Global Settings</h3>

            <div className="col-md-10">
                <h2 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: '20px' }}>SUBSCRIPTION PRICES</h2>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Max subscription price</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="0"
                            onChange={(e) => handleChange('max_subscription_price', e.target.value)}
                            value={state.max_subscription_price} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Min subscription price</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="0"
                            onChange={(e) => handleChange('min_subscription_price', e.target.value)}
                            value={state.min_subscription_price} />
                    </div>
                </div>

                <h2 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: '20px' }}>TIP PRICES</h2>
                {/* tip */}
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Max tip price</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            onChange={(e) => handleChange('max_tip_price', e.target.value)}
                            value={state.max_tip_price} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Min tip price</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            onChange={(e) => handleChange('min_tip_price', e.target.value)}
                            value={state.min_tip_price} />
                    </div>
                </div>

                <h2 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: '20px' }}>PPV PRICES</h2>
                {/* ppv */}
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Max PPV price</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            onChange={(e) => handleChange('max_ppv_price', e.target.value)}
                            value={state.max_ppv_price} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Min subscription price</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            onChange={(e) => handleChange('min_ppv_price', e.target.value)}
                            value={state.min_ppv_price} />
                    </div>
                </div>

                <h2 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: '20px' }}>ROWS TO DISPLAY PER PAGE</h2>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Max users per page</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            onChange={(e) => handleChange('max_users_per_page', e.target.value)}
                            value={state.max_users_per_page} />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Number of recently added posts</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            onChange={(e) => handleChange('recently_added_posts', e.target.value)}
                            value={state.recently_added_posts} />
                    </div>
                </div>

                <h2 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: '20px' }}>AUTO PAUSE DAYS</h2>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Number of days to pause inactive account</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="0"
                            onChange={(e) => handleChange('auto_pause_days', e.target.value)}
                            value={state.auto_pause_days} />
                    </div>
                </div>

                <h2 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: '20px' }}>CREDIT CARD VERIFICATION SETTINGS</h2>
                <p className="mb-4" style={{ fontSize: '12px' }}>
                    The CC verification process operates on all new subscribers when it is enabled.  When the enabling for specified users in checked on, then the verification is only done for specified users via the users page column called "Verify CC"
                </p>

                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>
                        Enable CC Verification Process
                    </label>
                    <div className="col-sm-4" style={{ textAlign: 'left' }}>
                        <input
                            type="checkbox"
                            className="form-control form-sm"
                            min="1"
                            onChange={(e) => handleChange('subscriber_account_verification', !state.subscriber_account_verification)}
                            checked={state.subscriber_account_verification}
                            style={{ width: '26px' }}
                        />
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Accumulated Transaction Threshold</label>
                    <div className="col-sm-4">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <div className="input-group-text">
                                    <span style={{ font: 'mono', fontWeight: 'bold' }}>$</span>
                                </div>
                            </div>
                            <input
                                type="number"
                                className="form-control"
                                min="1"
                                onChange={(e) => handleChange('ccver_threshold_amount', e.target.value)}
                                value={state.ccver_threshold_amount}
                                style={{
                                    padding: '0.375rem 0.75rem'
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Number Transaction Threshold</label>
                    <div className="col-sm-4" style={{ textAlign: 'left' }}>
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            onChange={(e) => handleChange('ccver_threshold_qty', e.target.value)}
                            value={state.ccver_threshold_qty}
                        />
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Start Registration Date</label>
                    <div className="col-sm-6" style={{ textAlign: 'left' }}>
                        <input
                            type="date"
                            className="form-control"
                            onChange={(e) => handleChange('ccver_registration_date', e.target.value)}
                            value={state.ccver_registration_date}
                            required
                        />
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>
                        Enable CC Verification for specified users only
                    </label>
                    <div className="col-sm-1" style={{ textAlign: 'left' }}>
                        <input
                            type="checkbox"
                            className="form-control form-sm"
                            min="1"
                            onChange={(e) => handleChange('specified_account_verification', !state.specified_account_verification)}
                            checked={state.specified_account_verification}
                            style={{ width: '26px' }}
                        />
                    </div>
                    <div className="col-sm-6" style={{ paddingLeft: '20px' }}>
                        Specify the SU's to be CC Verified via the <Link to="/administration/users">Users</Link> page. When selected, new subscribers are not CC verified. This is to be used during early release of this function.
                    </div>
                </div>

                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Maximum Zip Code Errors</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            onChange={(e) => handleChange('max_zip_error', e.target.value)}
                            value={state.max_zip_error} />
                    </div>
                </div>

                <h2 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: '20px' }}>MASS MAIL NOTIFICATION</h2>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Threshold for using mass mail</label>
                    <div className="col-sm-4" style={{ textAlign: 'left' }}>
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            onChange={(e) => handleChange('mass_min_users', e.target.value)}
                            value={state.mass_min_users}
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Mass Burst Quantity</label>
                    <div className="col-sm-4" style={{ textAlign: 'left' }}>
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            onChange={(e) => handleChange('mass_burst_qty', e.target.value)}
                            value={state.mass_burst_qty}
                        />
                    </div>
                </div>
                {/* <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Max Mass Mail Batch Users</label>
                    <div className="col-sm-4" style={{ textAlign: 'left' }}>
                        <input
                            type="number"
                            className="form-control"
                            min="1"
                            onChange={(e) => handleChange('max_mass_mail_batch_users', e.target.value)}
                            value={state.max_mass_mail_batch_users}
                        />
                    </div>
                </div> */}

                <h2 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: '20px' }}>STASH AND POST MEDIA DOWNLOAD</h2>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Maximum Filesize</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="100"
                            onChange={(e) => handleChange('max_filesize_download', e.target.value)}
                            value={state.max_filesize_download}
                            aria-describedby="filesizeHelp"
                        />
                        <small id="filesizeHelp" className="form-text text-muted">Maximum filesize to generate for download. Default to 100MB</small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Stash maximum number of files allowed</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            onChange={(e) => handleChange('max_stash_file_uploads', e.target.value)}
                            value={state.max_stash_file_uploads}
                            aria-describedby="numFilesHelp"
                        />
                        <small id="numFilesHelp" className="form-text text-muted">Maximum number of files allowed for stash upload</small>
                    </div>
                </div>

                <h2 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: '20px' }}>THUMBPRINT SETTINGS</h2>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Opacity</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            min="100"
                            onChange={(e) => handleChange('thumbprint_opacity', e.target.value)}
                            value={state.thumbprint_opacity}
                            aria-describedby="filesizeHelp"
                        />
                        <small id="filesizeHelp" className="form-text text-muted">Visibility of the thumbprint between 0 (not visible) and 1 (visible)</small>
                    </div>
                </div>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>Show Duration</label>
                    <div className="col-sm-4">
                        <input
                            type="number"
                            className="form-control"
                            onChange={(e) => handleChange('thumbprint_duration', e.target.value)}
                            value={state.thumbprint_duration}
                            aria-describedby="numFilesHelp"
                        />
                        <small id="numFilesHelp" className="form-text text-muted">Duration to show the thumbprint in milliseconds.</small>
                    </div>
                </div>

                <h2 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: '20px' }}>VERIFICATION CODE SETTINGS</h2>
                <div className="form-group row">
                    <label className="col-sm-4 col-form-label" style={{ paddingTop: 0, paddingRight: 0 }}>
                        Enable Signup Verification Code
                    </label>
                    <div className="col-sm-4" style={{ textAlign: 'left' }}>
                        <input
                            type="checkbox"
                            className="form-control form-sm"
                            min="1"
                            onChange={(e) => handleChange('signup_email_verify', !state.signup_email_verify)}
                            checked={state.signup_email_verify}
                            style={{ width: '26px' }}
                        />
                    </div>
                </div>

                <Button
                    variant="primary"
                    className="mt-3"
                    disabled={isBusy}
                    onClick={handleSave}>
                    {isBusy ? "Updating Changes..." : "Update Changes"}
                </Button>
            </div>
        </div>
    );
};

export default SystemGlobalSettings;
